import React, {Component} from 'react';
import NavBarKS from "../../components/NavBarKS";
import StickButton from "../../components/StickButton";
import Table from "../../components/Table/Table";
import {Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import moment from "moment";
import {request} from "../../helper/APIUtils";
import {showAxiosError} from "../../helper/helper";
import Alert from "react-s-alert";
import {TimelineModal} from "./TimelineModal";
import {EntegratorIdentifiers} from "../../helper/enums";

class Timeline extends Component {
    constructor(props) {
        super(props);
        this.state = {
            content: [],
            loading: false,
            manual: false,
            page: 0,
            size: 10,
            total: 0,
            addTimelineModal: false,
            selectedRow: null,
            mode: 'create',
            confirmDeleteModal: false,
            selectedTimeline: null
        }

        this.entegratorMap = Object.entries(EntegratorIdentifiers).reduce((acc, [key, value]) => {
            acc[value] = key;
            return acc;
        }, {});

        this.handleDelete = this.handleDelete.bind(this);
        this.confirmDelete = this.confirmDelete.bind(this);
        this.fetchData = this.fetchData.bind(this);
        this.onChange = this.onChange.bind(this);
        this.pageSize = this.pageSize.bind(this);
    }

    fetchData(accessor, direction, page, size) {
        let self = this;
        let sortStr = !!accessor ? ('&sort=' + accessor + ',' + direction) : '&sort=createdAt,desc';
        let searchQuery = !self.state.searchQuery ? '' : '&' + self.state.searchQuery;
        let params = {
            url: '/timeline/fetchTimeline?page=' + page + '&size=' + size + sortStr + searchQuery,
            method: "post",
        };
        self.setState({loading: true, manual: self.manual === true ? false : self.manual});
        self.props.reload(true);
        request(params)
            .then(function (response) {
                if (Array.isArray(response.data)) {
                    self.setState({
                        page: page,
                        size: size,
                        total: response.data.length || 0,
                        content: response.data,
                        loading: false,
                        searching: false,
                        selectedAll: false,
                        selection: [],
                    });
                } else {
                    throw new Error("Yanıt verileri beklenen yapıda değil.");
                }
                self.props.reload(false);
            }).catch(function (error) {
            console.error(error);
            self.setState({loading: false});
            self.props.reload(false);
            showAxiosError(error);
        });
    }

    onChange(current, pageSize) {
        this.pageSize(current - 1, pageSize);
    }

    pageSize(page, size) {
        this.setState({page: page, size: size});
        this.fetchData(this.state.accessor, this.state.direction, page, size);
    }

    handleDelete() {
        let self = this;
        let params = {
            url: '/timeline/deleteTimeline',
            method: "post",
            data: self.state.selectedTimeline
        };
        self.setState({loading: true, manual: self.manual === true ? false : self.manual});
        request(params)
            .then(function (response) {
                self.setState({
                    manual: true,
                    loading: false,
                    selectedTimeline: null,
                    confirmDeleteModal: false
                });
                Alert.success("Silindi.", {
                    position: 'top-right',
                    effect: 'stackslide',
                    timeout: 3000
                });
            })
            .catch(function (error) {
                self.setState({loading: false});
                showAxiosError(error);
            });
    }

    confirmDelete(item) {
        this.setState({
            selectedTimeline: item,
            confirmDeleteModal: true
        })
    }

    render() {

        const columns = [
            {
                Header: "Başlık",
                accessor: "title",
                Cell: row => (
                    <div
                        title={row.title || ''}>{row.title && row.title.length > 30 ? row.title.substring(0, 30) + '...' : row.title || ''}
                    </div>
                )
            },
            {
                Header: "Açıklama",
                accessor: "description",
                Cell: row => {
                    const parser = new DOMParser();
                    const doc = parser.parseFromString(row.description || '', 'text/html');
                    const plainText = doc.body.textContent || "";
                    return (
                        <div title={plainText}>
                            {plainText.length > 40 ? plainText.substring(0, 40) + '...' : plainText}
                        </div>
                    );
                }
            }
            ,
            {
                Header: "Gösterilme Tarihi",
                accessor: "showAt",
                Cell: row => (<div>{moment(row.showAt).isValid() ? moment(row.showAt).format("DD-MM-YYYY") : ''}</div>)
            },
            {
                Header: "Gösterilecek Entegratör",
                accessor: "showOn",
                Cell: row => {
                    const showOnValue = row.showOn || "";
                    const identifiers = showOnValue.split(',').map(id => this.entegratorMap[id] || id);
                    return (<div>{identifiers.join(', ')}</div>);
                }
            },
            {
                Header: "İşlemler",
                accessor: "",
                sortable: false,
                Cell: (item, index) => (
                    <div className="btn-group">

                        <div className="dropdown">
                            <button className="MenuBtn2 listt btn btn-default" type="button"
                                    data-toggle="dropdown">Seçİnİz
                            </button>
                            <div className="dropdown-menu" aria-labelledby={"dropdownMenuButton_" + item.recordId}>
                                <a className="dropdown-item" onClick={() => this.setState({
                                    mode: "update",
                                    recordId: item.recordId,
                                    addTimelineModal: true
                                })}>
                                    <i className="fa fa-edit"/> Düzenle
                                </a>

                                <a className="dropdown-item" onClick={() => this.confirmDelete(item)}>
                                    <i className="fa fa-trash-alt"/> Sil
                                </a>
                            </div>
                        </div>
                    </div>
                )
            }
        ];

        return (
            <div className="row baseBackground">

                <NavBarKS offsetWidth={this.props.offsetWidth} innerWidth={window.innerWidth}>
                    <StickButton className='stickButton plus-circle' position="leftSide"
                                 onClick={() => this.setState({mode: "create", addTimelineModal: true})}
                                 label="Yeni Oluştur"
                                 title="Yeni Oluştur"/>
                </NavBarKS>

                <div className="col-md-12 satirBasi">
                    <div className="card-header ">
                        <h4 className="card-title">Güncellemeler</h4>
                    </div>
                </div>

                <div className="card-body">
                    <Table columns={columns}
                           loading={this.state.loading}
                           loadingText="Kayıtlar getiriliyor..."
                           content={this.state.content}
                           total={this.state.total}
                           page={this.state.page}
                           manual={this.state.manual}
                           size={this.state.size}
                           options={["5", "10", "20", "50", "100"]}
                           fetchData={this.fetchData}
                    />
                </div>

                {this.state.addTimelineModal &&
                    <TimelineModal
                        mode={this.state.mode}
                        selectedRow={this.state.selectedRow}
                        modal={this.state.addTimelineModal}
                        listener={(addTimelineModal, manual) => this.setState({
                            addTimelineModal,
                            manual,
                            recordId: null
                        })}
                        recordId={this.state.recordId}
                    />
                }

                <Modal isOpen={this.state.confirmDeleteModal}>
                    <ModalHeader/>
                    <ModalBody>
                        Silmek istediğinizden emin misiniz ?
                    </ModalBody>
                    <ModalFooter>
                        <div className="col-sm-12 row">
                            <div className="col-sm-2">
                                <button type="button" data-toggle="tooltip" data-placement="bottom"
                                        style={{
                                            background: 'linear-gradient(rgba(125, 125, 125, 0.57), rgb(111, 111, 111))',
                                            padding: '11px 45px 11px 8px'
                                        }}
                                        rel="tooltip" className="TekBtn vazgec "
                                        onClick={() => this.setState({
                                            confirmDeleteModal: false,
                                            selectedTimeline: null
                                        })}>
                                    İptal
                                </button>
                            </div>
                            <div className="col-sm-8"/>

                            <div className="col-sm-2">
                                <button type="button" data-toggle="tooltip" data-placement="bottom"
                                        style={{
                                            background: 'linear-gradient(rgba(159, 208, 55, 0.6), #9fd037)',
                                            padding: '11px 45px 11px 8px'
                                        }}
                                        rel="tooltip" className="TekBtn kaydet"
                                        onClick={() => this.handleDelete()}>
                                    Tamam
                                </button>
                            </div>
                        </div>
                    </ModalFooter>
                </Modal>
            </div>
        );
    }
}

export default Timeline;